import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Table, Button, FormControl } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import moment from 'moment';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';

import Link from '../../Link/Link';
import CustomPagination from '../../CustomPagination/CustomPagination';
import Loader from '../../Common/Loader/Loader';

import deleteUser from '../../../actions/siteadmin/Users/deleteUser';
import messages from '../../../locale/messages';
import debounce from '../../../helpers/debounce';
import { editPartner } from '../../../actions/siteadmin/editPartner';
import { capitalizeFirstLetter } from '../../../helpers/capitalizeFirst';
import getCurrentPage from '../../../helpers/getCurrentPage';
import { demoRestriction, demoRestrictionEncode } from '../../../actions/demoRestriction';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { censorEmail, censorPhone, decode, censorWord } from '../../../helpers/queryEncryption';

import { CommonAdminEditIcon, CommonAdminTrashIcon, ExportCsvIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';

import bt from '../../../components/commonStyle.css';
import s from './PartnerList.css';

class PartnerList extends React.Component {
  static propTypes = {
    deletePartner: PropTypes.any
  };
  constructor(props) {
    super(props)
    this.state = {
      currentPage: 1,
      searchList: '',
      isRestrict: false,
    }
  }

  async componentDidMount() {
    const { demoRestrictionEncode } = this.props;
    const isRestrict = await demoRestrictionEncode({});
    this.setState({ isRestrict });
  }

  handleKeywordSearch = debounce((searchList) => {
    const { partnerDetails: { refetch } } = this.props;
    let variables = {
      currentPage: 1,
      searchList
    };
    this.setState(variables)
    refetch(variables);
  }, 250)

  handleDelete = async (profileId, currentPage, userType) => {
    const { deleteUser, partnerDetails: { getAllUsers, refetch }, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    currentPage = await getCurrentPage({ results: getAllUsers?.results, page: currentPage });
    let variables = { currentPage }
    const deleteUserResponse = await deleteUser(profileId, currentPage, userType);
    if (deleteUserResponse?.status === 200) {
      refetch(variables);
      this.setState({ currentPage });
    }
  }

  handleUserStatusChange = async (e, id, email, phoneDialCode, phoneNumber, isBan, phoneCountryCode, currentPage) => {
    const { editPartner, partnerDetails: { refetch }, demoRestriction } = this.props;
    let data = {}, variables;
    data = {
      id: id,
      email: email,
      phoneDialCode: phoneDialCode,
      phoneNumber: phoneNumber,
      userStatus: e.target.value,
      isBan: isBan,
      phoneCountryCode: phoneCountryCode
    }
    variables = { currentPage, userType: 2 };
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await editPartner(data);
    await refetch(variables);
  }

  handleBanStatusChange = async (e, id, email, phoneDialCode, phoneNumber, userStatus, phoneCountryCode, currentPage) => {
    const { editPartner, partnerDetails: { refetch }, demoRestriction } = this.props;
    let data = {}, variables;
    data = {
      id: id,
      email: email,
      phoneDialCode: phoneDialCode,
      phoneNumber: phoneNumber,
      userStatus: userStatus,
      isBan: Number(e.target.value),
      phoneCountryCode: phoneCountryCode
    }
    variables = { currentPage, userType: 2 };
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await editPartner(data);
    await refetch(variables);
  }

  paginationData = (currentPage) => {
    const { partnerDetails: { refetch } } = this.props;
    let variables = { currentPage, userType: 2 };
    this.setState({ currentPage });
    refetch(variables);
  }

  restrictExport = () => {
    showToaster({ messageId: 'disableDemo', toasterType: 'warning' })
  };

  render() {
    const { partnerDetails, partnerDetails: { loading } } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage, searchList, isRestrict } = this.state;
    let country;
    return (
      <div className={'whiteDropdown'}>
        <div className={s.exportDisplay}>
          <div className={s.searchGroupContainer}>
            <div className={cx(s.searchInput, 'searchInputRTL')}>
              <FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(e) => this.handleKeywordSearch(e.target && e.target.value)} className={bt.formControlInput} />
            </div>
          </div>
          <div className={cx(s.exportTextSection)}>
            {
              partnerDetails?.getAllUsers?.results && partnerDetails?.getAllUsers?.results?.length > 0 && (isRestrict ? <a
                href={`#`} className={cx(s.exportTextContainer)} onClick={() => this.restrictExport()}>
                <span className={cx(s.vtrMiddle, s.exportText, 'exportTextRTL')}><FormattedMessage {...messages.exportDataIntoCSV} /></span>
                <span className={cx(s.vtrTextBottom)}>
                  <ExportCsvIcon />
                </span>
              </a> : <a
                href={`/export-admin-data?type=serviceprovider&keyword=${searchList ? searchList : ''}`}
                className={cx(s.exportTextContainer)}>
                <span className={cx(s.vtrMiddle, s.exportText, 'exportTextRTL')}><FormattedMessage {...messages.exportDataIntoCSV} /></span>
                <span className={cx(s.vtrTextBottom)}>
                  <ExportCsvIcon />
                </span>
              </a>)
            }
          </div></div>

        {
          loading && <div>
            <Loader type="circle" />
          </div>
        }
        {
          !loading &&
          <div className='tableOuterContainer'>
            <Table className="tableContainer">
              <thead>
                <tr>
                  <th scope="col"><FormattedMessage {...messages.id} /></th>
                  <th scope="col"><FormattedMessage {...messages.firstName} /></th>
                  <th scope="col"><FormattedMessage {...messages.lastName} /></th>
                  <th scope="col" className='tableLargeHeading'><FormattedMessage {...messages.email} /></th>
                  <th scope="col"><FormattedMessage {...messages.country} /></th>
                  <th scope="col" className='tableLargeHeading'><FormattedMessage {...messages.phoneNumber} /></th>
                  <th scope="col" className='tableLargeHeading'><FormattedMessage {...messages.createdAt} /></th>
                  <th scope="col"><FormattedMessage {...messages.userStatus} /></th>
                  <th scope="col"><FormattedMessage {...messages.banStatus} /></th>
                  <th scope="col" className='tableLargeHeading'><FormattedMessage {...messages.manageServices} /></th>
                  <th scope="col"><FormattedMessage {...messages.action} /></th>
                  <th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
                </tr>
              </thead>
              <tbody>
                {
                  partnerDetails?.getAllUsers?.results && partnerDetails?.getAllUsers?.results?.length > 0 && partnerDetails?.getAllUsers?.results?.map((item, index) => {
                    country = item && item?.profile && item?.profile?.country;
                    return (
                      <tr key={index}>
                        <td data-label={formatMessage(messages.id)}>{item && item?.profile && item?.profile?.profileId}</td>
                        <td data-label={formatMessage(messages.firstName)}>{item && item?.profile && isRestrict ? censorWord(decode(item?.profile?.encryptFirstName)) : decode(item?.profile?.encryptFirstName)}</td>
                        <td data-label={formatMessage(messages.lastName)}>{item && item?.profile && isRestrict ? censorWord(decode(item?.profile?.encryptLastName)) : decode(item?.profile?.encryptLastName)}</td>
                        <td data-label={formatMessage(messages.email)} className='tableLargeHeading'>
                          {item?.encryptEmail && (isRestrict ? censorEmail(decode(item?.encryptEmail)) : decode(item?.encryptEmail))}
                        </td>
                        <td data-label={formatMessage(messages.country)}>{country}</td>
                        <td data-label={formatMessage(messages.phoneNumber)} className='tableLargeHeading'>
                          {item && item?.phoneDialCode}{item?.encryptPhoneNumber && (isRestrict ? censorPhone(decode(item?.encryptPhoneNumber)) : decode(item?.encryptPhoneNumber))}
                        </td>
                        <td data-label={formatMessage(messages.createdAt)} className='tableLargeHeading'>
                          {item.createdAt
                            ? moment(Number(item.createdAt)).format('DD-MM-YYYY HH:mm:ss')
                            : '-'}
                        </td>
                        <td data-label={formatMessage(messages.userStatus)}>
                          <div>
                            <select name="userStatus" className={bt.selectInput}
                              onChange={(e) => this.handleUserStatusChange(e, item?.id, decode(item?.encryptEmail), item?.phoneDialCode, decode(item?.encryptPhoneNumber), item?.isBan, item?.phoneCountryCode, currentPage)} value={item?.userStatus}>
                              <option value="pending">{formatMessage(messages.pending)}</option>
                              <option value="active">{formatMessage(messages.active)}</option>
                              <option value="inactive">{formatMessage(messages.inactive)}</option>
                            </select>
                          </div>
                        </td>
                        <td data-label={formatMessage(messages.banStatus)}>
                          <div>
                            <select name="isBan" className={bt.selectInput}
                              onChange={(e) => this.handleBanStatusChange(e, item?.id, decode(item?.encryptEmail), item?.phoneDialCode, decode(item?.encryptPhoneNumber), item?.userStatus, item?.phoneCountryCode, currentPage)} value={item?.isBan}>
                              <option value="0">{formatMessage(messages.permit)}</option>
                              <option value="1">{formatMessage(messages.ban)}</option>
                            </select>
                          </div>
                        </td>
                        <td data-label={formatMessage(messages.manageServices)}>
                          <div>
                            <Link to={"/siteadmin/partners/category/" + item?.profile?.profileId} className={s.noLink}>
                              <CommonAdminEditIcon className={cx(s.editIcon, 'editIconRTL')} />
                              <span className={s.vtrMiddle}>
                                <FormattedMessage {...messages.editAction} />
                              </span>
                            </Link>
                          </div>
                        </td>
                        <td data-label={formatMessage(messages.action)}>
                          <div>
                            <Link to={'/siteadmin/partners/' + item?.profile.profileId} className={s.noLink}>
                              <CommonAdminEditIcon className={cx(s.editIcon, 'editIconRTL')} />
                              <span className={s.vtrMiddle}>
                                <FormattedMessage {...messages.editAction} />
                              </span>
                            </Link>
                          </div>
                        </td>
                        <td data-label={formatMessage(messages.deleteAction)}>
                          <div>
                            <Button onClick={() => this.handleDelete(item.profile.profileId, currentPage, 2)} className={s.iconBtn}>
                              <CommonAdminTrashIcon className={cx(s.editIcon, 'editIconRTL')} />
                              <span className={s.vtrMiddle}>
                                <FormattedMessage {...messages.deleteAction} />
                              </span>
                            </Button>
                          </div>
                        </td>
                      </tr>
                    )
                  })
                }
                {
                  (!loading && (partnerDetails?.getAllUsers && partnerDetails?.getAllUsers?.results?.length == 0)) && (
                    <tr>
                      <td colspan="12" className={'tableNoRecordCel'}><FormattedMessage {...messages.noResult} /></td>
                    </tr>
                  )
                }
              </tbody>
            </Table>
          </div>
        }
        {
          partnerDetails?.getAllUsers?.results && partnerDetails?.getAllUsers?.results?.length > 0
          && <div className={cx(bt.space5, bt.spaceTop5)}>
            <CustomPagination
              total={partnerDetails?.getAllUsers?.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.partner)}
            />
          </div>
        }
      </div >
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = {
  deleteUser,
  editPartner,
  demoRestriction,
  demoRestrictionEncode
};

export default compose(injectIntl,
  withStyles(bt, s),
  connect(mapState, mapDispatch)
)(PartnerList);